import * as React from 'react';
import { connect } from 'react-redux';
import { IApplicationState } from 'src/state';
import './AppContextV2.scss';

export interface IContextProps {
  values: { [key: string]: string };
  additionalValues?: { [key: string]: string };
}

const AppContextV2: React.FunctionComponent<IContextProps> = (props) => {
  const { values, additionalValues } = props;
  return (
    <section id="app-context">
      <ul>
        {additionalValues &&
          Object.keys(additionalValues).map((key) => {
            return additionalValues[key] ? (
              <li key={key}>
                {key}: {additionalValues[key]}
              </li>
            ) : null;
          })}

        {Object.keys(values).map((key) => {
          return values[key] ? (
            <li key={key}>
              {key}: {values[key]}
            </li>
          ) : null;
        })}
      </ul>
    </section>
  );
};

const mapStateToProps = ({ layout }: IApplicationState) => ({
  values: layout.appContext
});

export default connect(mapStateToProps)(AppContextV2);
